import { LinkRoute } from '@/components/common/Link'
import { type WPPostType } from '@/defs/wordpress'
import { buildRoute } from '@/utils/routeUtil'

import styles from './ArticleTags.module.scss'

type Props = {
  tags?: WPPostType['tags']
}

export const ArticleTags = ({ tags }: Props) =>
  !!tags?.length && (
    <div className={styles.container}>
      <h3 className={styles.header}>Tags</h3>
      <ul className={styles.tagsList}>
        {tags.map((tag, i) => (
          <li key={i}>
            <LinkRoute className={styles.tag} href={buildRoute({ articleTagSlug: tag.slug, section: 'articlesTag' })}>
              {tag.name}
            </LinkRoute>
          </li>
        ))}
      </ul>
    </div>
  )
